module.exports = __webpack_public_path__ + "img/sert1Big.f567b581.png";